<script>
/** Utilities */
import _ from 'lodash'
import ArrayUtil from '../utilities/ArrayUtil'
import AppResourceUtil from '../utilities/AppResourceUtil'
/** APIs */
import FormFieldsApi from '../api/FormFieldsApi'
import IssueApi from '../api/IssueApi'
/** UI Components */
import { Checkbox } from 'buefy/dist/components/checkbox'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Radio } from 'buefy/dist/components/radio'
import { Select } from 'buefy/dist/components/select'
import { Switch } from 'buefy/dist/components/switch'
import { Table,TableColumn } from 'buefy/dist/components/table'

export default {
    name : "EditFormFieldsForm",
    components: {
        'b-checkbox' : Checkbox,
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-radio' : Radio,
        'b-select' : Select,
        'b-switch' : Switch,
        'b-table' : Table,
        'b-table-column' : TableColumn
    },
    props : {
        repGroupLov : Array,
        inputTypesLov : Array,
        originalFormData : Object,
        profile : Object,
        mode: String,
        newFormId: Number
    },
    data() {
        return {
            formFields : [],
            groupedFields: [],
            currentGrp: null,
            allExpanded: true
        }
    },
    computed : {
        hasFieldGroups () {
            var res = []
            if (this.groupedFields.length) {
                res = this.groupedFields.filter(grp => {
                    return grp.isField === false
                })
            }
            if (res.length > 0) {
                return true
            }
            return false
        },
        collapseAllLabel () {
            if (this.allExpanded) {
                return 'Collapse All Field Group'
            }
            return 'Expand All Field Group'
        },
        fieldsChanged(){
            // Check if there's unsaved changes in form fields form
            var errorCnt = 0;
            this.formFields.forEach(field=>{
                if (!field.fieldId || field.fieldId===undefined) {
                    if (field.fieldLabel.trim().length > 0 || 
                        field.fieldSubLabel.trim().length > 0 ||
                        field.fieldGroupLabel.trim().length > 0 ||
                        (field.fieldGroupSubLabel && field.fieldGroupSubLabel.trim().length > 0) ||
                        field.fieldTypeIdFk!=null || 
                        field.selectedPresetOption.trim().length > 0 ||
                        field.customDropdownOptions.length > 0) {
                        errorCnt++;
                    }
                }
                else {
                    if (this.isChanged(field,field.originalPropValues)) {
                        errorCnt++;
                    }
                }
            });
            if (errorCnt > 0) {
                return true;
            }
            return false
        }
    },
    created(){
        if (this.$route.params) {
            try {
                this.formId = parseInt(this.$route.params.formId,10)
            }
            catch(formIdErr){}
        }
        this.setFormFields();
    },
    methods : {
        setFormFields(){
            this.formFields = []
            
            if (this.originalFormData.formFields.length > 0) {
                this.originalFormData.formFields.forEach(field=>{

                    let currField = {};
                    let customOptValues = [];

                    for (var prop in field) {
                        if (prop!='optionType') {
                            this.$set(currField,prop,field[prop]);
                        }
                    }

                    this.$set(currField,'formIdFk',this.formId);
                    
                    // For dropdown field
                    this.$set(currField,'dropdownInput','');
                    this.$set(currField,'selectedPresetOption','');

                    if (field.inputType=='dropdown' ||
                        field.inputType=='checkbox' ||
                        field.inputType=='radio') {
                        if (field.optionType=='preset') {
                            this.$set(currField,'optionType','preset');
                            field.selectedPresetOption = ''
                            if (field.options.length > 0) {
                                field.selectedPresetOption = field.options[0].optionValue;
                                this.$set(currField,'selectedPresetOption',field.options[0].optionValue);
                            }   
                        }
                        else {
                            this.$set(currField,'optionType','custom');
                            if (field.options.length > 0) {
                                field.customDropdownOptions = [];
                                field.options.forEach(opt=>{
                                    field.customDropdownOptions.push(opt.optionValue)
                                    customOptValues.push(opt.optionValue)
                                })
                            }
                        }
                    }
                    else {
                        this.$set(currField,'optionType','preset');
                    }

                    this.$set(currField,'customDropdownOptions',customOptValues);

                    if (currField.fieldGroupSubLabel === null) {
                        this.$set(currField,'fieldGroupSubLabel','');
                    }


                    // Keep old values
                    // field.originalPropValues = Object.assign({},field);
                    this.$set(currField,'originalPropValues',Object.assign({},field));
                    
                    this.formFields.push(currField);
                });
            }

            if (this.formFields.length > 0) {
                this.groupFields()
            }
        },
        groupFields() {
            let currFieldGroup=null;
            let newGroupedFields = [];
            this.groupedFields = []
            if ( this.formFields ) {
                if ( this.formFields.length > 0) {
                    this.formFields.forEach(field=>{                        
                        if (field.fieldGroupLabel==currFieldGroup && field.fieldGroupLabel!="") {
                            field.grpSequenceNumber = this.groupedFields[this.groupedFields.length-1].fields.length
                            this.groupedFields[this.groupedFields.length-1].fields.push(field)
                        }
                        else {
                            field.grpSequenceNumber = 0
                            this.currentGrp = {}
                            this.$set(this.currentGrp, 'fieldGroupName', field.fieldGroupLabel)
                            this.$set(this.currentGrp, 'fieldGroupSubLabel', field.fieldGroupSubLabel ? field.fieldGroupSubLabel : '')
                            this.$set(this.currentGrp, 'fields', [field])
                            this.$set(this.currentGrp, 'expanded', true)
                            if (field.fieldGroupLabel === '') {
                                this.$set(this.currentGrp, 'isField', true)
                            } else {
                                this.$set(this.currentGrp, 'isField', false)
                            }
                            this.groupedFields.push(this.currentGrp)
                        }
                        currFieldGroup = field.fieldGroupLabel;
                    });
                }
            } 
        },
        hasOptions(id){
            let fieldTypes = ['dropdown','checkbox','radio'];
            let selectedInput = this.inputTypesLov.filter(inputType=>{
                return (inputType.typeId == id)
            });
            if (selectedInput[0]) {
                if (ArrayUtil.inArray(fieldTypes,selectedInput[0].inputType)){
                    return true;
                }
            }
            return false;
        },
        getInputType(id){
            let selectedInput = "";
            this.inputTypesLov.forEach(inputType=>{
                if (inputType.typeId==id) {
                    selectedInput = inputType.inputType;
                }
            });
            return selectedInput
        },
        addDropdownOption(fieldRow){
            if (fieldRow.row.dropdownInput.trim().length != 0) {
                // Check if existing already
                var res = fieldRow.row.customDropdownOptions.filter(option=>{
                    return (option==fieldRow.row.dropdownInput)
                })
                if (res.length==0) {
                    fieldRow.row.customDropdownOptions.push(fieldRow.row.dropdownInput.trim());
                    // Reset input
                    fieldRow.row.dropdownInput = "";
                }
            } 
        },
        removeDropdownOption(fieldRow,optIdx){
            fieldRow.row.customDropdownOptions.splice(optIdx,1);
        },
        addFieldRow(){
            this.formFields.push({
                fieldLabel : "",
                fieldSubLabel : "",
                fieldGroupLabel : "",
                isRequired : true,
                fieldTypeIdFk : null,
                optionType : "",
                selectedPresetOption : "",
                customDropdownOptions : [],
                hasMultipleInputValue : false,
                dropdownInput : "",
                sequenceNumber : this.formFields.length,
                addedBy: this.profile.userId,
                formIdFk: this.formId
            });
        },
        removeFieldRow(fieldRow, grp, spliceGroup){
            // Check if there's changes in the fields attributes;)
            if (fieldRow.row.fieldLabel.trim().length > 0 || 
                fieldRow.row.fieldSubLabel.trim().length > 0 ||
                fieldRow.row.fieldGroupLabel.trim().length > 0 ||
                fieldRow.row.fieldGroupSubLabel.trim().length > 0 ||
                fieldRow.row.fieldTypeIdFk!=null || 
                fieldRow.row.selectedPresetOption.trim().length > 0 ||
                fieldRow.row.customDropdownOptions.length > 0) {

                var useLabel = 'this field'
                if (fieldRow.row.fieldLabel !== '') {
                    useLabel += ` (${fieldRow.row.fieldLabel})`
                }
                // Confirm Action
                this.$dialog.confirm({
                    title: 'Confirmation',
                    message: `This action will delete ${useLabel}. What do you want to do?`,
                    cancelText: "Keep Field",
                    confirmText: 'Proceed & Remove Field',
                    type: 'is-danger',
                    onConfirm: () => {
                        if (fieldRow.row.fieldId!==undefined) {
                            // Delete field from DB
                            this.deleteField(fieldRow.row,fieldRow.index,grp,spliceGroup);
                        }
                        else {
                            if (!spliceGroup) {
                                // Delete field from group
                                this.groupedFields[grp.groupIdx].fields.splice(fieldRow.index, 1)
                            } else {
                                this.groupedFields.splice(grp.groupIdx, 1)
                            }
                            // Delete from display/view
                            // this.formFields.splice(fieldRow.index,1);
                        }
                    }
                })
                return false;
            }
            if (fieldRow.row.fieldId!==undefined) {
                // Delete field from DB
                this.deleteField(fieldRow.row,fieldRow.index,grp,spliceGroup);
            }
            else {
                // Delete from display/view
                // this.formFields.splice(fieldRow.index,1);
                // this.updateFieldSequence()
                if (!spliceGroup) {
                    // Delete field from group
                    this.groupedFields[grp.groupIdx].fields.splice(fieldRow.index, 1)
                } else {
                    this.groupedFields.splice(grp.groupIdx, 1)
                }
                this.updateSequenceViaGroup();
            }
        },
        deleteField(field,fieldIdxInGrp,grp,spliceGrp){            
            FormFieldsApi.delete(field.fieldId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        // Remove from display/view
                        // this.formFields.splice(rowIdx,1);
                        // this.updateFieldSequence()
                        if (spliceGrp) {
                            this.groupedFields.splice(grp.groupIdx, 1)
                        } else {
                            this.groupedFields[grp.groupIdx].fields.splice(fieldIdxInGrp, 1)
                        }
                        this.updateSequenceViaGroup();

                        this.$notification.open({
                            duration: 5000,
                            message: 'Field removed.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                    }
                    else {
                        this.promptServerError({response},'FormFields.delete')
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormFields.delete') 
            });
        },
        updateFieldSequence () {
            this.formFields.forEach((field,index)=>{
                field.sequenceNumber = index
            });
            /* var inputFields = [];
            var dropdownFields = [];
            var errorCnt = 0;
            this.formFields.forEach(field=>{
                if (field.fieldTypeIdFk!=null && field.fieldLabel!="") {
                    if (this.hasOptions(field.fieldTypeIdFk)==true) {
                        if (!field.fieldId || field.fieldId===undefined) {
                        }
                        else {
                            dropdownFields.push(field);
                        }
                    }
                    else {
                        if (!field.fieldId || field.fieldId===undefined) {
                        }
                        else {
                            inputFields.push(field);
                        }
                    }
                }
            });

            if (inputFields.length > 0) { 
                this.validateExistingInputFields(inputFields,0,true);
            }
            if (dropdownFields.length > 0) {
                this.validateExisitingDropdownFields(dropdownFields,0,true);
            } */
        },
        isChanged(newField,oldField){
            for (var prop in newField) {
                if (prop!='originalPropValues' && prop!='dropdownInput') {
                    if (this.hasOptions(newField.fieldTypeIdFk)==false) {
                        if (prop!='optionType') {
                            if (newField.hasOwnProperty(prop) && oldField.hasOwnProperty(prop)) {
                                if (newField[prop]!=oldField[prop]) {
                                    return true;
                                }
                            }
                        }
                    }
                    else {
                        if (newField.hasOwnProperty(prop) && oldField.hasOwnProperty(prop)) {
                            if (prop!=='customDropdownOptions') {
                                if (newField[prop]!=oldField[prop]) {
                                    return true;
                                }
                            }
                            else {
                                if (JSON.stringify(newField[prop])!=JSON.stringify(oldField[prop])) {
                                    return true
                                }
                            }
                        }
                    }
                }
            }
            return false;
        },
        closeFieldMgt(){
            // Check if there's unsaved changes in form fields form
            if (this.fieldsChanged) {
                // Confirm Action
                this.$dialog.confirm({
                    title: 'Confirmation',
                    message: 'You have unsaved changes. Are you sure you want to leave this page?',
                    cancelText: "Stay",
                    confirmText: 'Leave Page',
                    type: 'is-warning',
                    onConfirm: () => {
                        this.$router.push({path:"/admin/forms"});
                    }
                })
                return false;
            }

            // Go back to /forms
            this.$router.push({path:"/admin/forms"});
        },
        saveFormFields(closeEditView){
            /** Copy mode */
            if (this.mode && this.mode == 'Copy') {
                var fieldsWithOpts = [];
                var fieldsWithoutOpts = [];
                var errorCnt = 0;

                this.formFields.forEach(field=>{
                    if (field.fieldLabel=="") {
                        errorCnt++;
                    }
                    if (field.fieldTypeIdFk==null) {
                        errorCnt++;
                    }
                    if (field.fieldTypeIdFk!=null && field.fieldLabel!="") {
                        if (this.hasOptions(field.fieldTypeIdFk)) {
                            if (this.getInputType(field.fieldTypeIdFk)=='dropdown') {
                                if (field.selectedPresetOption.trim().length==0 && 
                                    field.customDropdownOptions.length==0) {    
                                    errorCnt++;
                                }
                            }
                            if (this.getInputType(field.fieldTypeIdFk)=='checkbox' || 
                                this.getInputType(field.fieldTypeIdFk)=='radio') {
                                if (field.customDropdownOptions.length==0) {    
                                    errorCnt++;
                                }
                            }
                            if (field.selectedPresetOption.trim().length > 0) {
                                field.optionType = "preset";
                            }
                            else if (field.customDropdownOptions.length > 0) {
                                field.optionType = "custom";
                            }
                            // fieldsWithOpts.push(field);
                            fieldsWithOpts.push({
                                addedBy: this.profile.userId,
                                customDropdownOptions: field.customDropdownOptions,
                                dropdownInput: field.dropdownInput,
                                fieldGroupLabel: field.fieldGroupLabel,
                                fieldGroupSubLabel: field.fieldGroupSubLabel,
                                fieldLabel: field.fieldLabel,
                                fieldSubLabel: field.fieldSubLabel,
                                fieldTypeIdFk: field.fieldTypeIdFk,
                                formIdFk: this.newFormId,
                                hasMultipleInputValue: false,
                                isRequired: field.isRequired,
                                optionType: field.optionType,
                                selectedPresetOption: field.selectedPresetOption,
                                selectedPresetOptions: field.selectedPresetOptions,
                                sequenceNumber: field.sequenceNumber
                            });
                        }
                        else {
                            // fieldsWithoutOpts.push(field) 
                            fieldsWithoutOpts.push({
                                addedBy: this.profile.userId,
                                customDropdownOptions: field.customDropdownOptions,
                                dropdownInput: field.dropdownInput,
                                fieldGroupLabel: field.fieldGroupLabel,
                                fieldGroupSubLabel: field.fieldGroupSubLabel,
                                fieldLabel: field.fieldLabel,
                                fieldSubLabel: field.fieldSubLabel,
                                fieldTypeIdFk: field.fieldTypeIdFk,
                                formIdFk: this.newFormId,
                                hasMultipleInputValue: false,
                                isRequired: field.isRequired,
                                optionType: field.optionType,
                                selectedPresetOption: field.selectedPresetOption,
                                selectedPresetOptions: [],
                                sequenceNumber: field.sequenceNumber
                            });
                        }
                    }
                });

                if (errorCnt > 0) {
                    this.$notification.open({
                        duration: 5000,
                        message: 'Please check the required fields. <br/> <ul><li><strong>&nbsp;&nbsp;Field Label</strong></li><li><strong>&nbsp;&nbsp;Input Type</strong></li><li><strong>&nbsp;&nbsp;Dropdown Options <i>(*For dropdown input type)</i></strong></li></ul>',
                        position: 'is-bottom-left',
                        type: 'is-danger'
                    });
                    return false;
                }

                this.$emit('save-fields-copy',{
                    fields: fieldsWithoutOpts,
                    dropdownFields: fieldsWithOpts,
                    publish: 0
                })
                // this.saveInputFields(fieldsWithoutOpts,fieldsWithOpts,0);
            }
            else {
                /** Edit mode */
                this.updateFieldSequence()
                
                var newInputFields = [], inputFields = [];
                var newDropdownFields = [], dropdownFields = [];
                var errorCnt = 0;
                this.formFields.forEach(field=>{
                    // For New Fields
                    if (field.fieldLabel=="") {
                        errorCnt++;
                    }
                    if (field.fieldTypeIdFk==null) {
                        errorCnt++;
                    }
                    
                    if (field.fieldTypeIdFk!=null && field.fieldLabel!="") {
                        if (this.hasOptions(field.fieldTypeIdFk)==true) {
                            if (this.getInputType(field.fieldTypeIdFk)=='dropdown' &&
                                field.selectedPresetOption.trim().length==0 && 
                                field.customDropdownOptions.length==0) {    
                                errorCnt++;
                            }
                            if ( (this.getInputType(field.fieldTypeIdFk)=='checkbox' || 
                                this.getInputType(field.fieldTypeIdFk)=='radio' ) &&
                                field.customDropdownOptions.length==0) {    
                                errorCnt++;
                            }

                            // If not an existing field; new field
                            if (!field.fieldId || field.fieldId===undefined) {
                                if (field.selectedPresetOption.trim().length > 0) {
                                    field.optionType = "preset";
                                }
                                else if (field.customDropdownOptions.length > 0) {
                                    field.optionType = "custom";
                                }
                                newDropdownFields.push(field);
                            }
                            else {
                                dropdownFields.push(field);
                            }
                        }
                        else {
                            field.optionType = "";
                            if (!field.fieldId || field.fieldId===undefined) {
                                newInputFields.push(field);
                            }
                            else {
                                inputFields.push(field);
                            }
                        }
                    }
                    
                });

                if (errorCnt > 0) {
                    this.$notification.open({
                        duration: 5000,
                        message: 'Please check the required fields. <br/> <ul><li><strong>&nbsp;&nbsp;Field Label</strong></li><li><strong>&nbsp;&nbsp;Input Type</strong></li><li><strong>&nbsp;&nbsp;Dropdown Options <i>(*For dropdown input type)</i></strong></li></ul>',
                        position: 'is-bottom-left',
                        type: 'is-danger'
                    });
                    return false;
                }

                if (newInputFields.length > 0 || newDropdownFields.length > 0) {
                    this.addNewInputFields(
                        newInputFields,
                        newDropdownFields,
                        closeEditView
                    );
                }

                if (inputFields.length > 0) { 
                    this.validateExistingInputFields(inputFields,closeEditView);
                }
                if (dropdownFields.length > 0) {
                    this.validateExisitingDropdownFields(dropdownFields,closeEditView);
                }
            }
        },
        validateExistingInputFields(inputFields,closeEditView,isSeqUpdate){
            let updatedInputFields = [];
            inputFields.forEach(field=>{
                let changedFields = [];
                let removeOptions = false;
                if (field.fieldLabel!==field.originalPropValues.fieldLabel) {
                    changedFields.push({
                        'field' : 'fieldLabel',
                        'newValue' : field.fieldLabel 
                    });
                }
                if (field.fieldSubLabel!==field.originalPropValues.fieldSubLabel) {
                    changedFields.push({
                        'field' : 'fieldSubLabel',
                        'newValue' : field.fieldSubLabel 
                    });
                }
                if (field.fieldGroupLabel!==field.originalPropValues.fieldGroupLabel) {
                    changedFields.push({
                        'field' : 'fieldGroupLabel',
                        'newValue' : field.fieldGroupLabel 
                    });
                }
                if (field.fieldGroupSubLabel!==field.originalPropValues.fieldGroupSubLabel) {
                    changedFields.push({
                        'field' : 'fieldGroupSubLabel',
                        'newValue' : field.fieldGroupSubLabel 
                    });
                }
                if (field.fieldTypeIdFk!==field.originalPropValues.fieldTypeIdFk) {
                    changedFields.push({
                        'field' : 'fieldTypeIdFk',
                        'newValue' : field.fieldTypeIdFk 
                    });

                    if (this.hasOptions(field.fieldTypeIdFk)) {
                        if (this.getInputType(field.fieldTypeIdFk)=='dropdown') {
                            if (field.optionType!==field.originalPropValues.optionType) {
                                changedFields.push({
                                    'field' : 'optionType',
                                    'newValue' : field.optionType 
                                });
                            }
                        }
                    }
                    else {
                        // If field has changed from having options to none
                        if (this.hasOptions(field.originalPropValues.fieldTypeIdFk)==true) {
                            removeOptions = true;
                        }
                    }

                }

                if (field.hasMultipleInputValue!==field.originalPropValues.hasMultipleInputValue) {
                    changedFields.push({
                        'field' : 'hasMultipleInputValue',
                        'newValue' : field.hasMultipleInputValue 
                    });
                }
                if (field.isRequired!==field.originalPropValues.isRequired) {
                    changedFields.push({
                        'field' : 'isRequired',
                        'newValue' : field.isRequired 
                    });
                }
                if (field.sequenceNumber!==field.originalPropValues.sequenceNumber) {
                    changedFields.push({
                        'field' : 'sequenceNumber',
                        'newValue' : field.sequenceNumber 
                    });
                }

                // Only those fields with changes will be updated
                if (changedFields.length > 0) {
                    updatedInputFields.push({
                        formIdFk : this.formId,
                        fieldId : field.fieldId,
                        changedFields : changedFields,
                        removeOptions : removeOptions,
                        updatedBy : this.profile.userId
                    });
                }
            })

            // Run update ONLY IF there are fields that need to be updated
            if (updatedInputFields.length > 0) {
                this.updateInputFields(updatedInputFields,closeEditView,isSeqUpdate)
            }
        },
        updateInputFields(inputFields,closeEditView,isSeqUpdate) {
            FormFieldsApi.updateInputFields(inputFields)
            .then(response=>{
                let d = response.data;
                if (response.data) {
                    if (!response.data.error) {
                        if (d.totalCount==d.requestCount ||
                            d.totalUpdated==d.requestCount) {
                            var msg = 'updated.'
                            if (isSeqUpdate) {
                                msg = 'sequence updated.'
                            }
                            this.$notification.open({
                                duration: 3000,
                                message: 'Input fields '+msg,
                                position: 'is-bottom-left',
                                type: 'is-success'
                            });
                        }
                    }
                    else {
                        this.promptServerError({response},'FormFields.updateInputFields');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormFields.updateInputFields');
            });
        },
        addNewInputFields(inputFields,dropdownFields,closeForm){
            
            FormFieldsApi.add(inputFields)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.addNewDropdownFields(dropdownFields,closeForm);
                    }
                    else {
                        this.promptServerError({response},'FormFields.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormFields.add');
            });
        },
        addNewDropdownFields(dropdownFields,closeForm){
            FormFieldsApi.addOne(dropdownFields)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.$notification.open({
                            duration: 3000,
                            message: 'Fields added!',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        this.$emit('get-updated-fields',true)
                    }
                    else {
                        this.promptServerError({response},'FormFields.addOne');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormFields.addOne');
            });
        },
        validateExisitingDropdownFields(dropdownFields,closeEditView,isSeqUpdate){
            let updatedDropdownFields = [];
            dropdownFields.forEach(field=>{
                let changedFields = [];
                // let removeOptions = false;
                let newOptions = false;
                let optionsChanged = false;

                if (field.fieldLabel!==field.originalPropValues.fieldLabel) {
                    changedFields.push({
                        'field' : 'fieldLabel',
                        'newValue' : field.fieldLabel 
                    });
                }
                if (field.fieldSubLabel!==field.originalPropValues.fieldSubLabel) {
                    changedFields.push({
                        'field' : 'fieldSubLabel',
                        'newValue' : field.fieldSubLabel 
                    });
                }
                if (field.fieldGroupLabel!==field.originalPropValues.fieldGroupLabel) {
                    changedFields.push({
                        'field' : 'fieldGroupLabel',
                        'newValue' : field.fieldGroupLabel 
                    });
                }
                if (field.fieldTypeIdFk!==field.originalPropValues.fieldTypeIdFk) {
                    // If input type changed
                    changedFields.push({
                        'field' : 'fieldTypeIdFk',
                        'newValue' : field.fieldTypeIdFk 
                    });
                }
                
                if (this.hasOptions(field.fieldTypeIdFk)) {
                    if (this.getInputType(field.fieldTypeIdFk)=='dropdown') {
                        if (field.optionType!==field.originalPropValues.optionType) {
                            changedFields.push({
                                'field' : 'optionType',
                                'newValue' : field.optionType 
                            });
                            optionsChanged = true;
                            // Reset options accordingly; 
                            // depending on selected option type
                            if (field.optionType=='preset') {
                                if (field.customDropdownOptions.length > 0) {
                                    field.customDropdownOptions = [];
                                }
                            }
                            else {
                                field.selectedPresetOption = "";
                            }
                        }
                        else {
                            if (field.optionType=='preset') {
                                if (field.selectedPresetOption!=field.originalPropValues.selectedPresetOption) {
                                    optionsChanged = true;
                                }
                            }
                            else {
                                if (JSON.stringify(field.customDropdownOptions)!=JSON.stringify(field.originalPropValues.customDropdownOptions)) {
                                    optionsChanged = true;
                                }
                            }
                            
                        }

                    }
                    else {
                        // Add code for checkbox / radio
                        if (JSON.stringify(field.customDropdownOptions)!=JSON.stringify(field.originalPropValues.customDropdownOptions)) {
                            optionsChanged = true;
                        }
                    }
                    
                }

                if (field.hasMultipleInputValue!==field.originalPropValues.hasMultipleInputValue) {
                    changedFields.push({
                        'field' : 'hasMultipleInputValue',
                        'newValue' : field.hasMultipleInputValue 
                    });
                }
                if (field.isRequired!==field.originalPropValues.isRequired) {
                    changedFields.push({
                        'field' : 'isRequired',
                        'newValue' : field.isRequired 
                    });
                }
                if (field.sequenceNumber!==field.originalPropValues.sequenceNumber) {
                    changedFields.push({
                        'field' : 'sequenceNumber',
                        'newValue' : field.sequenceNumber 
                    });
                }

                if (changedFields.length > 0 || optionsChanged==true) {
                    updatedDropdownFields.push({
                        formIdFk : this.formId,
                        fieldId : field.fieldId,
                        selectedPresetOption : field.selectedPresetOption,
                        customDropdownOptions : field.customDropdownOptions,
                        optionType : field.optionType,
                        changedFields,
                        optionsChanged,
                        updatedBy : this.profile.userId
                    });
                }
            });

            // Run update ONLY IF there are fields that need to be updated
            if (updatedDropdownFields.length > 0) {
                this.updateDropdownFields(updatedDropdownFields,closeEditView,isSeqUpdate)
            }
        },
        updateDropdownFields(dropdownFields,closeEditView,isSeqUpdate){
            FormFieldsApi.updateDropdownFields(dropdownFields)
            .then(response=>{
                if (response.data) {
                    let d = response.data;
                    if (!response.data.error) {
                        if (d.addOptionsError==true ||
                            d.deleteOptionsError==true) {
                            this.$notification.open({
                                duration: 3000,
                                message: 'An error occurred while changing dropdown options.',
                                position: 'is-bottom-left',
                                type: 'is-error'
                            });
                            return false;
                        }

                        if (d.totalUpdated==d.requestCount || d.totalUpdated>d.requestCount) {
                            var msg = 'updated.'
                            if (isSeqUpdate) {
                                msg = 'sequence updated.'
                            }
                            this.$notification.open({
                                duration: 3000,
                                message: 'Dropdown fields '+msg,
                                position: 'is-bottom-left',
                                type: 'is-success'
                            });
                        }
                    }
                    else {
                        this.promptServerError({response},'FormFields.updateDropdownFields');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormFields.updateDropdownFields');
            });
        },
        switchOptionType(grp,field,optType) {
            if (grp && grp.fieldGroup) {
                this.groupedFields[grp.groupIdx].fields[field.index] = optType
            }
            // this.formFields[field.index].optionType = optType;
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        addToPositionNew(grp, currField, position, isGroup) {
            /** 
             * type (String) - can be 'field' or 'group'
             * indicates what will be added
            */
            var newFieldData = {
                fieldLabel : "",
                fieldSubLabel : "",
                fieldGroupLabel : "",
                fieldGroupSubLabel: "",
                isRequired : true,
                fieldTypeIdFk : null,
                optionType : "",
                selectedPresetOption : "",
                customDropdownOptions : [],
                hasMultipleInputValue : false,
                dropdownInput : "",
                sequenceNumber : null,
                grpSequenceNumber: null,
                addedBy: this.profile.userId,
                formIdFk: this.formId
            }

            /** 
             * Check if group is not empty; field is added to group
             * 
             * Apply group label and/or group sub label
             * 
             * Check position: after, before, null
             * if position is after or before, check reference field (currField)
             * 
             * if position is null - add as last field of the group
             * 
             * if position is before/after - get index of reference field
             * - set sequence number of new field
             * 
             * Add new field to group
             * Add new field to formFields
             * 
             * Loop through formFields to assign new sequenceNumbers 
             */

            if (!grp) {
                /** Add field and group at the end */
                newFieldData.grpSequenceNumber = 0
                newFieldData.sequenceNumber = this.formFields.length
                this.newFieldAndGroup(newFieldData, true,  {
                    newFieldSequenceNum: newFieldData.sequenceNumber,
                    newGroupIndex: null,
                    isGroup: isGroup
                })
            } else {
                /**
                 * If add is triggered from:
                 * 
                 * Field group options (field, group)
                 * Field options (field, group)
                 * Field group add action at the bottom (field)
                  */
                if (!currField) {
                    /** To add outside the group */
                    if (!position) {
                        /** 
                         * Add last field/group to group 
                         * When 'Add new field to group' to group is clicked
                        */
                        /** Add field and group at the end */
                        if (grp.fieldGroup.fieldGroupName && grp.fieldGroup.fieldGroupName !== '') {
                            newFieldData.fieldGroupLabel = grp.fieldGroup.fieldGroupName
                        }
                        if (grp.fieldGroup.fieldGroupSubLabel && grp.fieldGroup.fieldGroupSubLabel !== '') {
                            newFieldData.fieldGroupSubLabel = grp.fieldGroup.fieldGroupSubLabel
                        }                        
                        newFieldData.grpSequenceNumber = grp.fieldGroup.length
                        this.groupedFields[grp.groupIdx].fields.push(newFieldData)                        
                        /** Update form fields array */
                        this.updateSequenceViaGroup() 
                    } else {
                        /** 
                         * Add field or field group from field group menu option
                         * */
                        var newGroupIdx = null
                        var isLast = false
                        newFieldData.grpSequenceNumber = 0
                        if (position === 'before') {
                            newFieldData.sequenceNumber = this.groupedFields[grp.groupIdx].fields[0].sequenceNumber
                            newGroupIdx = grp.groupIdx 
                        } else {
                            newFieldData.sequenceNumber = this.groupedFields[grp.groupIdx].fields[this.groupedFields[grp.groupIdx].fields.length-1].sequenceNumber + 1
                            newGroupIdx = grp.groupIdx + 1
                        }
                        if (newGroupIdx === this.groupedFields.length) {
                            isLast = true
                        }
                        this.newFieldAndGroup(newFieldData, isLast, {
                            newFieldSequenceNum: newFieldData.sequenceNumber,
                            newGroupIndex: newGroupIdx,
                            isGroup: isGroup
                        })
                    }
                } else {
                    /** Triggered from field (add) menu */

                    /** 
                     * Check if add is triggered from individual field (grp.fieldGroup.isField) or 
                     * from field within group */

                    /** 
                     * If triggered from field without group name */
                    if (grp.fieldGroup && grp.fieldGroup.isField) {
                        var newGroupIdx = null
                        var isLast = false
                        newFieldData.grpSequenceNumber = 0
                        if (position === 'before') {
                            newFieldData.sequenceNumber = this.groupedFields[grp.groupIdx].fields[0].sequenceNumber
                            newGroupIdx = grp.groupIdx 
                        } else {
                            newFieldData.sequenceNumber = this.groupedFields[grp.groupIdx].fields[this.groupedFields[grp.groupIdx].fields.length-1].sequenceNumber + 1
                            newGroupIdx = grp.groupIdx + 1
                        }
                        if (newGroupIdx === this.groupedFields.length) {
                            isLast = true
                        }
                        this.newFieldAndGroup(newFieldData, isLast, {
                            newFieldSequenceNum: newFieldData.sequenceNumber,
                            newGroupIndex: newGroupIdx,
                            isGroup: isGroup
                        })
                    } else {
                        /** 
                         * If triggered from field in a field group
                         * */
                        if (grp.fieldGroup.fieldGroupName && grp.fieldGroup.fieldGroupName !== '') {
                            newFieldData.fieldGroupLabel = grp.fieldGroup.fieldGroupName
                        }
                        if (grp.fieldGroup.fieldGroupSubLabel && grp.fieldGroup.fieldGroupSubLabel !== '') {
                            newFieldData.fieldGroupSubLabel = grp.fieldGroup.fieldGroupSubLabel
                        } 
                        if (position === 'before') {
                            newFieldData.grpSequenceNumber = currField.row.grpSequenceNumber
                            newFieldData.sequenceNumber = currField.index 
                        } else {
                            newFieldData.grpSequenceNumber = currField.row.grpSequenceNumber + 1
                            newFieldData.sequenceNumber = currField.index + 1
                        }
                        if (newFieldData.grpSequenceNumber === this.groupedFields[grp.groupIdx].fields.length) {
                            this.groupedFields[grp.groupIdx].fields.push(newFieldData)
                        } else {
                            var updatedFieldsInGroup = []
                            this.groupedFields[grp.groupIdx].fields.forEach((gfield,gfieldIdx) => {
                                if (gfieldIdx === newFieldData.grpSequenceNumber ) {
                                    updatedFieldsInGroup.push(newFieldData)
                                }
                                updatedFieldsInGroup.push(gfield)
                            })
                            this.groupedFields[grp.groupIdx].fields = updatedFieldsInGroup
                        }

                        /** Update field sequence */
                        this.groupedFields[grp.groupIdx].fields.forEach((gfield,gfieldIdx) => {
                            gfield.grpSequenceNumber = gfieldIdx
                        })
                                            
                        /** Update form fields array */
                        this.updateSequenceViaGroup() 
                    }
                }
            }
        },
        newFieldAndGroup(newFieldData, addToEnd, seqNumData) {
            /** 
             * When (Add Field) is clicked
             * Adds field at the end
             * 
             * Create new field group with empty group name */
            this.currentGrp = {}
            this.$set(this.currentGrp, 'fieldGroupName', '')
            this.$set(this.currentGrp, 'fieldGroupSubLabel', '')
            this.$set(this.currentGrp, 'fields', [newFieldData])
            this.$set(this.currentGrp, 'expanded', true)
            if (seqNumData.isGroup) {
                this.$set(this.currentGrp, 'isField', false)
            } else {
                this.$set(this.currentGrp, 'isField', true)
            }            
            
            if (addToEnd) {
                /** Push new group to last */
                this.groupedFields.push(this.currentGrp)
                /** Push new field to the last */
                this.formFields.push(newFieldData)

                /** Update form fields array */
                this.updateSequenceViaGroup()  
            } else {
                /** Insert new group to position */
                var updatedFieldGroup = []
                this.groupedFields.forEach((grp,grpIdx) => {
                    if (grpIdx === seqNumData.newGroupIndex ) {
                        updatedFieldGroup.push(this.currentGrp)
                    }
                    updatedFieldGroup.push(grp)
                })
                this.groupedFields = updatedFieldGroup
                /** Add new field to the new position */
                this.addFieldRowToPos(newFieldData, seqNumData.newFieldSequenceNum)
            }
        },
        addFieldRowToPos(newFieldData, idx) {
            var updatedFormFields = []
            this.formFields.forEach((field,fieldIdx) => {
                if (fieldIdx === idx ) {
                    updatedFormFields.push(newFieldData)
                }
                field.sequenceNumber = fieldIdx + 1
                updatedFormFields.push(field)
            })
            this.formFields = updatedFormFields
            /** Update form fields array */
            this.updateSequenceViaGroup()
        },
        updateSequenceViaGroup () {
            var newFormFields = []
            if (this.groupedFields.length > 0) {
                this.groupedFields.forEach(grp => {
                    if (grp.fields.length > 0) {
                        grp.fields.forEach(field => {
                            field.sequenceNumber = newFormFields.length
                            newFormFields.push(field)
                        })
                    }
                })
            }
            this.formFields = newFormFields
        },
        confirmDeleteFieldGroup(grp) {
            if (grp) {
                if (grp.fieldGroup.fields.length > 0) {
                    this.$dialog.confirm({
                        title: 'Confirmation',
                        message: 'This action will remove this field group and its field/s. What do you want to do?',
                        cancelText: "Keep Group & Fields",
                        confirmText: 'Remove Group & Fields',
                        type: 'is-danger',
                        onConfirm: () => {
                            this.deleteFieldGroup(grp)
                        }
                    })
                }
            }
        },
        removeFieldNew(grp,currField) {
            /**
             * {
             *   fieldGroup: grp,
             *   groupIdx: grpIdx
             * },{
             *   index: fieldIdx,
             *   row: field
             * }
             * */

            /**
             * Check if field group or field
             */
            if (grp) {
                if (grp.fieldGroup.isField) {
                    /**
                     * If field, check if there are changes
                     */
                    this.removeFieldRow(currField, grp, true)
                } else {
                    if (grp.fieldGroup.fields.length === 1) {
                        /** Show additional message that removing this field will remove the whole group */
                        this.$dialog.confirm({
                            title: 'Confirmation',
                            message: 'Removing this field will also remove the whole group. What do you want to do?',
                            cancelText: "Keep Field",
                            confirmText: 'Remove Field',
                            type: 'is-danger',
                            onConfirm: () => {
                                if (currField.row.fieldId!==undefined) {
                                    // Delete field from DB
                                    this.deleteField(currField.row,currField.index,grp,true);
                                }
                                else {
                                    // Delete from display/view
                                    this.groupedFields.splice(grp.groupIdx, 1)
                                    this.updateSequenceViaGroup()
                                }
                            }
                        })
                    } else {
                        this.removeFieldRow(currField, grp, false)
                    }
                }
            }
        },
        updateGroupDetails: _.debounce((currentGroup) => {
            if (currentGroup.fields.length > 0) {
                var grpName = ''
                var grpSubLabel = ''
                if (currentGroup.fieldGroupName !== '') {
                    grpName = currentGroup.fieldGroupName
                }
                if (currentGroup.fieldGroupSubLabel !== '') {
                    grpSubLabel = currentGroup.fieldGroupSubLabel
                }
                currentGroup.fields.forEach(field => {
                    field.fieldGroupLabel = grpName
                    field.fieldGroupSubLabel = grpSubLabel
                })
            }
        }, 2000),
        toggleAllGroups () {
            this.allExpanded = !this.allExpanded 
            if (this.groupedFields.length > 0) {
                this.groupedFields.forEach(grp => {
                    if (grp.isField === false) {
                        grp.expanded = this.allExpanded
                    }
                })
            }
        },
        deleteFieldGroup(grp){
            var newFieldsToDelete = []
            var existingFieldsToDelete = []
            if (grp) {
                if (grp.fieldGroup.fields.length > 0) {
                    newFieldsToDelete = grp.fieldGroup.fields.filter(f => {
                        return !f.fieldId 
                    })
                    existingFieldsToDelete = grp.fieldGroup.fields.filter(f => {
                        return (f.fieldId && f.fieldId !== null)
                    })
                }
            }
            if (existingFieldsToDelete.length > 0) {
                var promiseArr = []
                existingFieldsToDelete.forEach(field => {
                    promiseArr.push(FormFieldsApi.delete(field.fieldId))
                })
                if (promiseArr.length > 0) {
                    Promise.all(promiseArr)
                    .then(result => {
                        if (result.length > 0) {
                            result.forEach((response,idx)=>{
                                if (response.data) {
                                    if (!response.data.error) {
                                        if (idx === result.length-1 ) {
                                            this.groupedFields.splice(grp.groupIdx, 1)
                                            this.$notification.open({
                                                duration: 5000,
                                                message: 'Field group removed.',
                                                position: 'is-bottom-left',
                                                type: 'is-success'
                                            });
                                            this.updateSequenceViaGroup();
                                        }
                                    }   
                                    else {
                                        this.promptServerError({response},'FormFields.delete')
                                    }
                                }
                            })
                        }
                    })
                    .catch(err=> {
                        console.log(err)
                    })
                }
            } else {
                if (newFieldsToDelete.length > 0) {
                    this.groupedFields.splice(grp.groupIdx, 1)
                    this.$notification.open({
                        duration: 5000,
                        message: 'Field group removed.',
                        position: 'is-bottom-left',
                        type: 'is-success'
                    });
                    this.updateSequenceViaGroup();
                }
            }

            
        }
    }
}
</script>

<template>
    <div class="box form-fields-box">

        <div v-if="hasFieldGroups">
            <a class="button is-light is-small"
                v-on:click="toggleAllGroups">
                <span>{{collapseAllLabel}}</span>
                <span class="icon">
                    <i class="fas fa-caret-up"
                        v-if="allExpanded"></i>
                    <i class="fas fa-caret-down"
                        v-else></i>
                </span>
            </a>
        </div>

        <div class="fields-table">

            <ul v-if="groupedFields.length > 0">
                <li 
                    class="field-group-box"
                    v-for="(grp,grpIdx) in groupedFields"
                    v-bind:key="grpIdx">
                    <div 
                        v-if="grp.isField === false">
                        <b-field grouped>
                            
                            <div class="control">
                                <b-dropdown>
                                    <button type="button"
                                        class="button is-small is-white"
                                        slot="trigger"
                                        role="button">
                                        <span class="icon fa-sm">
                                            <i class="fas fa-ellipsis-v fa-lg"></i>
                                        </span>
                                    </button>

                                    <b-dropdown-item
                                        @click="addToPositionNew({
                                            fieldGroup: grp,
                                            groupIdx: grpIdx
                                        },null,'before',false)">
                                        Add field before {{grp.fieldGroupName}}
                                    </b-dropdown-item>

                                    <b-dropdown-item
                                        @click="addToPositionNew({
                                            fieldGroup: grp,
                                            groupIdx: grpIdx
                                        },null,'after',false)">
                                        Add field after {{grp.fieldGroupName}}
                                    </b-dropdown-item>

                                    <hr class="dropdown-divider" />

                                    <b-dropdown-item
                                        @click="addToPositionNew({
                                            fieldGroup: grp,
                                            groupIdx: grpIdx
                                        },null,'before',true)">
                                        Add field group before {{grp.fieldGroupName}}
                                    </b-dropdown-item>

                                    <b-dropdown-item
                                        @click="addToPositionNew({
                                            fieldGroup: grp,
                                            groupIdx: grpIdx
                                        },null,'after',true)">
                                        Add field group after {{grp.fieldGroupName}}
                                    </b-dropdown-item>

                                    <hr class="dropdown-divider" />

                                    <b-dropdown-item
                                        v-on:click="confirmDeleteFieldGroup({
                                            fieldGroup: grp,
                                            groupIdx: grpIdx
                                        })">
                                        Delete field group (Including Fields)
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>

                            <p class="control">
                                <button 
                                    type="button"
                                    class="button is-white is-rounded is-small tooltip is-tooltip-top"
                                    :data-tooltip="grp.expanded ? 'Click to hide field/s' : 'Click to show field/s'" 
                                    @click="grp.expanded = !grp.expanded">
                                    <span class="icon">
                                        <i class="fas fa-caret-up"
                                            v-if="grp.expanded"></i>
                                        <i class="fas fa-caret-down"
                                            v-else></i>
                                    </span>
                                </button>
                            </p>

                            <div class="field is-horizontal"
                                style="width:45%;max-width:48%">
                                <div class="field-label is-small">
                                    <label class="label">Field Group</label>
                                </div>
                                <div class="field-body">
                                    <b-input 
                                        size="is-small"
                                        type="text"
                                        v-model="grp.fieldGroupName"
                                        expanded
                                        @input="updateGroupDetails(grp)"
                                        style="width:99%"></b-input>
                                </div>
                            </div>

                            <div class="field is-horizontal"
                                style="width:45%;max-width:48%">
                                <div class="field-label is-small"
                                    style="min-width:130px">
                                    <label class="label">Field Group Sublabel</label>
                                </div>
                                <div class="field-body">
                                    <b-input 
                                        size="is-small"
                                        type="text"
                                        v-model="grp.fieldGroupSubLabel"
                                        @input="updateGroupDetails(grp)"
                                        style="width:99%"></b-input>
                                </div>
                            </div>
                        </b-field>
                    </div>
                    <hr style="margin:0.2rem auto;margin-bottom:0.7rem;"
                        v-if="grp.isField === false && grp.expanded"/>
                    <div v-if="grp.expanded">
                        <div v-if="grp.fields.length > 0">
                            <!-- Fields -->
                            <div class="columns"
                                v-for="(field,fieldIdx) in grp.fields"
                                v-bind:key="fieldIdx">
                                <div class="column is-1">
                                    <div class="buttons are-small">
                                        <b-dropdown aria-role="list">
                                            <button class="button is-white tooltip is-tooltip-top"
                                                data-tooltip="Add New Field" 
                                                slot="trigger" 
                                                slot-scope="{ active }">
                                                <span class="icon ">
                                                    <i class="fas fa-plus"></i>
                                                </span>
                                            </button>

                                            <b-dropdown-item aria-role="listitem"
                                                @click="addToPositionNew({
                                                    fieldGroup: grp,
                                                    groupIdx: grpIdx
                                                },{
                                                    index: fieldIdx,
                                                    row: field
                                                },'before',false)">
                                                Add field before 
                                                <span v-if="field.fieldLabel">
                                                    {{field.fieldLabel}}
                                                </span>
                                                <span v-else>
                                                    this field
                                                </span>
                                            </b-dropdown-item>
                                            <b-dropdown-item aria-role="listitem"
                                                @click="addToPositionNew({
                                                    fieldGroup: grp,
                                                    groupIdx: grpIdx
                                                },{
                                                    index: fieldIdx,
                                                    row: field
                                                },'after',false)">
                                                Add field after 
                                                <span v-if="field.fieldLabel">
                                                    {{field.fieldLabel}}
                                                </span>
                                                <span v-else>
                                                    this field
                                                </span>
                                            </b-dropdown-item>

                                            <hr class="dropdown-divider" 
                                                v-if="grp.isField"/>
                                            <!-- Add Field Group Option -->
                                            <b-dropdown-item aria-role="listitem"
                                                v-if="grp.isField"
                                                @click="addToPositionNew({
                                                    fieldGroup: grp,
                                                    groupIdx: grpIdx
                                                },null,'before',true)">
                                                Add field group before 
                                                <span v-if="field.fieldLabel">
                                                    {{field.fieldLabel}}
                                                </span>
                                                <span v-else>
                                                    this field
                                                </span>
                                            </b-dropdown-item>
                                            <b-dropdown-item aria-role="listitem"
                                                v-if="grp.isField"
                                                @click="addToPositionNew({
                                                    fieldGroup: grp,
                                                    groupIdx: grpIdx
                                                },null,'after',true)">
                                                Add field group after 
                                                <span v-if="field.fieldLabel">
                                                    {{field.fieldLabel}}
                                                </span>
                                                <span v-else>
                                                    this field
                                                </span>
                                            </b-dropdown-item>

                                        </b-dropdown>
                                        <button type="button"
                                            class="button is-white"
                                            v-on:click="removeFieldNew({
                                                    fieldGroup: grp,
                                                    groupIdx: grpIdx
                                                },{
                                                index: fieldIdx,
                                                row: field
                                            })">
                                            <span class="icon ">
                                                <i class="fas fa-trash"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                                <div class="column">
                                    <b-field>
                                        <b-input 
                                            placeholder="Field Label"
                                            type="text"
                                            size="is-small"
                                            v-model="field.fieldLabel"
                                            required>
                                        </b-input>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field>
                                        <b-input 
                                            placeholder="Field Sublabel"
                                            type="text"
                                            size="is-small"
                                            v-model="field.fieldSubLabel">
                                        </b-input>
                                    </b-field>
                                </div>
                                <div class="column is-1">
                                    <b-checkbox 
                                        class="tooltip is-tooltip-top"
                                        data-tooltip="Is field required?"
                                        placeholder="Required"
                                        size="is-small"
                                        v-model="field.isRequired">
                                        Required
                                    </b-checkbox>
                                </div>
                                <div class="column is-2">
                                    <b-field>
                                        <b-select 
                                            placeholder="Choose Input Type"
                                            size="is-small"
                                            v-model="field.fieldTypeIdFk"
                                            required>
                                            <option value="">None selected</option>
                                            <option 
                                                v-for="(inputType,inputTypeIdx) in inputTypesLov"
                                                v-bind:key="inputTypeIdx"
                                                v-bind:value="inputType.typeId">
                                                {{inputType.inputType}}
                                            </option>
                                        </b-select>
                                    </b-field>
                                </div>
                                <div class="column is-2">
                                    <div v-if="field.fieldTypeIdFk!=null && getInputType(field.fieldTypeIdFk)=='dropdown'">
                                        
                                        <div class="buttons has-addons are-small">
                                            <span class="button tooltip is-tooltip-top"
                                                data-tooltip="Use Preset Options"
                                                v-bind:class="{'is-info is-selected':field.optionType=='preset'}"
                                                v-on:click="field.optionType = 'preset'">
                                                Preset
                                            </span>
                                            <span class="button tooltip is-tooltip-top"
                                                data-tooltip="Use Custom Options"
                                                v-bind:class="{'is-info is-selected':field.optionType=='custom'}"
                                                v-on:click="field.optionType = 'custom'">
                                                Custom
                                            </span>
                                        </div>

                                        <div v-if="field.optionType=='preset'">

                                            <div class="field">
                                                <b-radio 
                                                    size="is-small"
                                                    v-model="field.selectedPresetOption"
                                                    native-value="Reporting Entities">
                                                    Reporting Entities
                                                </b-radio>
                                            </div>
                                            <div class="field">
                                                <b-radio 
                                                    size="is-small"
                                                    v-model="field.selectedPresetOption"
                                                    native-value="Reporting Entities & Units">
                                                    Reporting Entities & Units
                                                </b-radio>
                                            </div>
                                        </div>

                                        <div v-if="field.optionType=='custom'">

                                            <b-field>
                                                <b-input 
                                                    placeholder="Key in option name"
                                                    type="text"
                                                    size="is-small"
                                                    v-model="field.dropdownInput"
                                                    v-on:keyup.native.13="addDropdownOption({
                                                        row: field,
                                                        index: fieldIdx
                                                    })">
                                                </b-input>
                                                <p class="control">
                                                    <button 
                                                        class="button is-small"
                                                        title="Add Option"
                                                        v-on:click="addDropdownOption({
                                                            row: field,
                                                            index: fieldIdx
                                                        })">
                                                        <span class="icon">
                                                            <i class="fas fa-plus"></i>
                                                        </span>
                                                    </button>
                                                </p>
                                            </b-field>

                                            <!-- List of custom options -->
                                            <div class="tags"
                                                v-if="field.customDropdownOptions.length">
                                                <span class="tag is-small is-info"
                                                    v-for="(ddOpt,ddOptIdx) in field.customDropdownOptions"
                                                    v-bind:key="ddOptIdx">
                                                    {{ddOpt}}
                                                    <button class="delete is-small"
                                                        v-on:click="removeDropdownOption({
                                                            row: field,
                                                            index: fieldIdx
                                                        },ddOptIdx)"></button>
                                                </span>
                                            </div>

                                        </div>

                                    </div>

                                    <!-- For checkbox/radio -->
                                    <div v-if="field.fieldTypeIdFk!=null && (getInputType(field.fieldTypeIdFk)=='checkbox' || getInputType(field.fieldTypeIdFk)=='radio')">

                                        <b-field>
                                            <b-input 
                                                placeholder="Key in option name"
                                                type="text"
                                                size="is-small"
                                                v-model="field.dropdownInput"
                                                v-on:keyup.native.13="addDropdownOption({
                                                    index: fieldIdx,
                                                    row: field
                                                })">
                                            </b-input>
                                            <p class="control">
                                                <button 
                                                    class="button is-small"
                                                    title="Add Option"
                                                    v-on:click="addDropdownOption({
                                                        index: fieldIdx,
                                                        row: field
                                                    })">
                                                    <span class="icon">
                                                        <i class="fas fa-plus"></i>
                                                    </span>
                                                </button>
                                            </p>
                                        </b-field>

                                        <!-- List of custom options -->
                                        <div class="tags"
                                            v-if="field.customDropdownOptions.length">
                                            <span class="tag is-small is-info"
                                                v-for="(ddOpt,ddOptIdx) in field.customDropdownOptions"
                                                v-bind:key="ddOptIdx">
                                                {{ddOpt}}
                                                <button class="delete is-small"
                                                    v-on:click="removeDropdownOption({
                                                        row: field,
                                                        index: fieldIdx
                                                    },ddOptIdx)"></button>
                                            </span>
                                        </div>

                                    </div>

                                    <small class="is-italic has-text-grey-light"
                                        v-if="field.fieldTypeIdFk==null || hasOptions(field.fieldTypeIdFk)==false">Not Applicable</small>
                                </div>
                            </div>
                        </div>
                        <div v-else
                            class="text-center">
                            <div class="content has-text-grey has-text-centered">
                                <p>No field found.</p>
                            </div>
                        </div>
                    </div>
                    <hr 
                        style="margin:0.2rem auto;margin-top:0.7rem;margin-bottom:0.7rem;" 
                        v-if="grp.isField === false"/>
                    <div
                        v-if="grp.isField === false">
                        <a class="button is-text is-small"
                            v-on:click="addToPositionNew({
                                fieldGroup: grp,
                                groupIdx: grpIdx
                            },null, null, false)">
                            <span>Add new field to the group</span>
                        </a>&nbsp;|&nbsp;
                        <small class="has-text-weight-semibold is-textis-small"
                        @click="grp.expanded = true">Number of fields: {{grp.fields.length}}</small>
                    </div>
                </li>
            </ul>
            <div v-else
                class="text-center">
                <div class="content has-text-grey has-text-centered">
                    <p>
                        <b-icon
                            icon="emoticon-sad"
                            size="is-large">
                        </b-icon>
                    </p>
                    <p>No data found.</p>
                </div>
            </div>
        </div>

        <hr />
        
        <div class="columns">
            <div class="column is-narrow has-text-left">
                <a class="button is-info is-outlined"
                    v-on:click="addToPositionNew(null, null, null, true)">
                    <span>New Field Group</span>
                </a>
                <a class="button is-info is-outlined"
                    v-on:click="addToPositionNew(null, null, null, false)">
                    <span>New Field</span>
                </a>
            </div>                  
            <div class="column">
                <button class="button"
                    type="button"
                    v-on:click="closeFieldMgt">
                    Cancel
                </button>
                <button class="button is-success"
                    type="button"
                    v-on:click="saveFormFields(1)"
                    v-bind:disabled="(!mode && !fieldsChanged)">
                    {{ (mode && mode=='Copy') ? 'Copy Fields' : 'Save Fields'}}
                </button>
            </div>  
        </div>

    </div>
</template>

<style scoped>
.dropdown.add-field-menu.is-active.is-mobile-modal > .dropdown-menu > .dropdown-content {
    max-height: 150px !important;
    overflow-y:scroll
}

.th-wrap,
.thlabel-is-small {
    font-size: 0.75rem !important;
}

</style>




// WEBPACK FOOTER //
// src/components/EditFormFieldsFormGrouped.vue